import axiosInstance from "../common/api";
import TablePage from "../components/TablePage";
import { useNavigate } from "react-router";
import SimpleTablePage from "../common/SimpleTablePage";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    fixed: "left",
    width: 70,
  },
  {
    title: "Nome",
    key: "courseType",
    dataIndex: "name",
    ellipsis: true,
    width: 150,
  },
  {
    key: "requiredCourse",
    dataIndex: ["requiredCourse", "title"],
    title: "Corso richiesto",
    ellipsis: true,
    width: 100,
  },
];

export default function () {
  return (
    <div>
      <SimpleTablePage title="Categorie nomine" resource="appointmentType" columns={columns} />
    </div>
  );
}
